import { render, staticRenderFns } from "./LostLeadsIndex.vue?vue&type=template&id=5d06c78f"
import script from "./LostLeadsIndex.vue?vue&type=script&lang=ts"
export * from "./LostLeadsIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports